import { useEffect } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import ModalBasicLayout from "../../../../components/Modal/ModalBasicLayout";
import ContainerModalActions from "../../../../components/Containers/ContainerModalActions";
import {
  SECTION_BUYER_PERSONA_TITLE,
  BUTTON_CANCEL,
  BUTTON_SAVE,
  SECTION_BUYER_PERSONA_PLACEHOLDER_NAME,
  SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION,
  FIELD_REQUIRED,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import TextField from "../../../../components/Form/TextField";
import { BRAND_EDIT_MULTILINE_ROWS } from "../utils/constants";

export const ModalBuyerPersona = ({
  modalOpen,
  onCloseModal,
  name: initialName = "",
  text: initialText = "",
  onSave,
}) => {
  const { t } = useTranslationApp();
  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: initialName || "",
      text: initialText || "",
    },
  });

  useEffect(() => {
    if (modalOpen) {
      reset({
        name: initialName || "",
        text: initialText || "",
      });
    }
  }, [modalOpen, initialName, initialText, reset]);

  const onSaveBuyerPersona = ({ name = "", text = "" }) => {
    onSave?.({ name: name || "", text: text || "" });
    onCloseModal();
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(SECTION_BUYER_PERSONA_TITLE)}
      maxWidth="sm"
      fullWidth
      enableHistoryManagement={false}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
        <TextField
          control={control}
          name="name"
          variant="filled"
          label={t(SECTION_BUYER_PERSONA_PLACEHOLDER_NAME)}
          fullWidth
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          errors={errors}
        />
        <TextField
          control={control}
          name="text"
          variant="filled"
          label={t(SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION)}
          multiline
          minRows={BRAND_EDIT_MULTILINE_ROWS}
          maxRows={BRAND_EDIT_MULTILINE_ROWS}
          fullWidth
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          errors={errors}
        />
      </Box>
      <DialogActions sx={{ p: 0, pt: 2 }}>
        <ContainerModalActions
          hasPadding={true}
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_CANCEL,
            onClick: onCloseModal,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            onClick: handleSubmit(onSaveBuyerPersona),
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalBuyerPersona;
